import config from '../config';


const createShopifyKioskRequest = (payload) => {
  return fetch(`${config.API_URL}integrations/shopify/kiosk`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
}

export const requestShopifyPosKiosk = async (staffId, queryParams) => {
  const payload = {
    ...Object.fromEntries(queryParams),
    'staffId': staffId,
  };

  const response = await createShopifyKioskRequest(payload);
  const json = await response.json();

  if (!response.ok) {
    throw new Error(JSON.stringify(json.message));
  }

  return {
    url: json.url
  };
}
